/* Shared cart behavior. Shopify remains the source of prices and discounts. */
(function () {
  'use strict';
  if (window.MDCart) return;
  var busy = false, opener = null, bodyWasLocked = false;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function drawer() { return document.querySelector('cart-drawer'); }
  function openDrawer(source) {
    var d = drawer(); if (!d) return;
    if (!d.classList.contains('is-open')) { opener = source && typeof source.focus === 'function' ? source : document.activeElement; bodyWasLocked = document.body.classList.contains('overflow-hidden'); }
    d.classList.add('is-open'); document.body.classList.add('overflow-hidden');
    var panel = d.querySelector('#CartDrawer'); if (panel) panel.focus({ preventScroll: true });
  }
  function closeDrawer() {
    var d = drawer(); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); if (!bodyWasLocked) document.body.classList.remove('overflow-hidden');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  }
  function showError(message) { document.querySelectorAll('[data-md-cart-error]').forEach(function (el) { el.textContent = message; el.hidden = false; }); }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('[data-md-qty-plus],[data-md-qty-minus],[data-md-remove],[data-md-checkout],[data-md-cart-offer] button').forEach(function (el) { el.disabled = value; });
    document.querySelectorAll('[data-md-items]').forEach(function (el) { el.setAttribute('aria-busy', String(value)); });
  }
  function animateShipping(container, previous) {
    var bar = container.querySelector('[data-md-fsbar]'); if (!bar || !Number.isFinite(previous)) return;
    var target = Number(bar.dataset.progress);
    if(target >= 100){ if(previous < 100) bar.classList.add('is-celebrating'); return; }
    if(target !== previous) bar.classList.add('is-driving');
    bar.style.setProperty('--md-progress', Math.min(100, Math.max(0, previous)) + '%');
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (bar.isConnected) bar.style.setProperty('--md-progress', target + '%'); }); });
  }
  function replaceContents(current, fresh) {
    var bar = current.querySelector('[data-md-fsbar]'), previous = bar ? Number(bar.dataset.progress) : 0;
    var scroll = current.querySelector('.md-drawer__body'), top = scroll ? scroll.scrollTop : 0;
    current.innerHTML = fresh.innerHTML;
    scroll = current.querySelector('.md-drawer__body'); if (scroll) scroll.scrollTop = top;
    animateShipping(current, previous);
  }
  async function refreshDrawer() {
    var page = document.querySelector('[data-md-page]'), ids = ['cart-drawer', 'cart-icon-bubble'];
    if (page) ids.push(page.dataset.sectionId);
    var url = new URL(window.location.href); url.searchParams.set('sections', ids.join(','));
    var response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('Your cart was updated. Please refresh the page to see it.');
    var sections = await response.json(), parser = new DOMParser();
    var doc = parser.parseFromString(sections['cart-drawer'] || '', 'text/html');
    var fresh = doc.querySelector('#CartDrawer'), current = document.querySelector('#CartDrawer');
    // Use the same server-rendered total for the mobile navigation and drawer.
    var countNode = fresh && fresh.querySelector('.md-cart-count');
    var itemCount = countNode ? Number(countNode.textContent.trim()) : NaN;
    if (Number.isInteger(itemCount) && itemCount >= 0) {
      document.querySelectorAll('.md-mnav__badge').forEach(function (badge) {
        badge.textContent = itemCount;
        badge.hidden = itemCount === 0;
      });
    }
    if (current) {
      if (!fresh) throw new Error('Your cart was updated. Please refresh the page to see it.');
      replaceContents(current, fresh);
      drawer().classList.toggle('is-empty', doc.querySelector('cart-drawer').classList.contains('is-empty'));
    }
    var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'] || '', 'text/html');
    var freshBubble = bubbleDoc.querySelector('#cart-icon-bubble'), bubble = document.querySelector('#cart-icon-bubble');
    if (freshBubble && bubble) bubble.innerHTML = freshBubble.innerHTML;
    if (page) {
      var pageDoc = parser.parseFromString(sections[page.dataset.sectionId] || '', 'text/html');
      var freshPage = pageDoc.querySelector('[data-md-page]');
      if (!freshPage) throw new Error('Your cart was updated. Please refresh the page to see it.');
      replaceContents(page, freshPage);
    }
    setBusy(busy);
  }
  async function responseData(response) {
    var data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'We could not update your cart. Please try again.');
    return data;
  }
  async function changeQty(key, quantity, action, scope) {
    if (busy) return; setBusy(true);
    try {
      await responseData(await fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:quantity})}));
      await refreshDrawer();
      var container = document.querySelector(scope);
      var row = container && Array.from(container.querySelectorAll('[data-md-item]')).find(function (el) { return el.dataset.key === key; });
      var focus = row && row.querySelector(action);
      if (!focus && container) focus = container.querySelector('[data-md-remove], [data-md-close], .md-cart-button');
      setBusy(false); if (focus) focus.focus({preventScroll:true});
    } catch (error) { showError(error.message); }
    finally { setBusy(false); }
  }
  window.MDCart = {open:openDrawer,close:closeDrawer,refresh:refreshDrawer};
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-md-close]')) { closeDrawer(); return; }
    if (e.target.closest('#cart-icon-bubble') && drawer()) { e.preventDefault(); openDrawer(); return; }
    var button = e.target.closest('[data-md-qty-plus],[data-md-qty-minus],[data-md-remove]'); if (!button || busy) return;
    var item = button.closest('[data-md-item]'); if (!item) return;
    var quantity = parseInt(item.querySelector('[data-md-qty-val]').textContent,10) || 1;
    var action = button.hasAttribute('data-md-remove') ? '[data-md-remove]' : button.hasAttribute('data-md-qty-plus') ? '[data-md-qty-plus]' : '[data-md-qty-minus]';
    var next = action === '[data-md-remove]' ? 0 : quantity + (action === '[data-md-qty-plus]' ? 1 : -1);
    changeQty(item.dataset.key, Math.max(0,next), action, button.closest('cart-drawer') ? '#CartDrawer' : '[data-md-page]');
  });
  document.addEventListener('keydown', function (e) {
    var d=drawer(); if (!d || !d.classList.contains('is-open')) return;
    if (e.target !== document.body && !d.contains(e.target)) return; // App dialogs own their focus.
    if (e.key === 'Escape') { closeDrawer(); return; } if (e.key !== 'Tab') return;
    var elements=Array.from(d.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),summary,[tabindex="0"]')).filter(function(el){return el.getClientRects().length && el.tabIndex>=0;});
    var first=elements[0],last=elements[elements.length-1];
    if (e.shiftKey && (document.activeElement===first || document.activeElement.id==='CartDrawer')) {e.preventDefault();if(last)last.focus();}
    else if (!e.shiftKey && document.activeElement===last) {e.preventDefault();if(first)first.focus();}
  });
  document.addEventListener('submit', async function (e) {
    var form=e.target; if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-md-ajax-add')) return;
    e.preventDefault(); if(busy || form.dataset.mdBusy)return; form.dataset.mdBusy='true';setBusy(true);
    var isOffer=form.hasAttribute('data-md-cart-offer');
    var button=form.querySelector('[type="submit"]');if(button)button.disabled=true;
    var message=form.querySelector('[data-md-add-message]'), label=button && button.textContent, added=false;
    if(message){message.hidden=true;message.textContent='';if(button)button.textContent='Adding…';}
    form.setAttribute('aria-busy','true');
    try {
      await responseData(await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}}));
      added=true;
      await refreshDrawer();openDrawer(button);
      if(message){message.textContent='Added to cart';message.hidden=false;}
      if(isOffer){setBusy(false);var nextOffer=document.querySelector('[data-md-cart-offer] button') || document.querySelector('[data-md-checkout]');if(nextOffer)nextOffer.focus({preventScroll:true});}
    } catch(error) {
      var errorText=added ? 'Added to cart. Please refresh the page to see your updated cart.' : error.message;
      if(message){message.textContent=errorText;message.hidden=false;}
      openDrawer(button);showError(errorText);
    }
    finally {delete form.dataset.mdBusy;form.removeAttribute('aria-busy');setBusy(false);if(button){button.disabled=false;if(message)button.textContent=label;}}
  });
})();
